import { useTenant } from "@/providers/session";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { GET_ALL_EMAIL_FORWARDINGS } from "./get-all";

type CreateEmailForwardingInput = {
  alias?: string;
  description?: string;
};

export const useCreateEmailForwarding = () => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const [createEmailForwarding, { data, loading, error }] = useMutation(
    CREATE_EMAIL_FORWARDING_MUTATION,
    {
      refetchQueries: [GET_ALL_EMAIL_FORWARDINGS],
    },
  );

  const handleCreateEmailForwarding = async (
    input: CreateEmailForwardingInput,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    toast.promise(
      createEmailForwarding({
        variables: {
          tenantId,
          ...input,
        },
      }),
      {
        success: () => {
          onSuccess();
          return t("generic_success");
        },
        error: () => {
          onError();
          return t("generic_error", { richColors: true });
        },
      },
    );
  };

  return {
    createEmailForwarding: handleCreateEmailForwarding,
    data: data?.createEmailForwarding,
    loading,
    error,
  };
};

export const CREATE_EMAIL_FORWARDING_MUTATION = gql`
  mutation CreateEmailForwarding(
    $tenantId: String!
    $alias: String
    $description: String
  ) {
    createEmailForwarding(
      tenantId: $tenantId
      alias: $alias
      description: $description
    ) {
      emailForwardingId
      forwardingAddress
      isActive
      alias
      description
      createdAt
      updatedAt
    }
  }
`;
